import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { IconButton } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker, dateTimePickerToolbarClasses } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { CalenderIconBlack } from '../../assets/images';
import { systemColor } from '../../theme/systemColor';
import { pickersToolbarTextClasses } from '@mui/x-date-pickers/internals';
import theme from '../../theme/theme';
var DateTimePickerComponent = function (props) {
    var _a, _b;
    // Set the minimum date to the current date and time
    var minDate = dayjs(new Date());
    var _c = useState(false), isOpenDateTimePicker = _c[0], setIsOpenDateTimePicker = _c[1];
    var _d = useState(props.selectedDate ? dayjs(props.selectedDate) : null), internalDate = _d[0], setInternalDate = _d[1];
    useEffect(function () {
        if (props.selectedDate) {
            setInternalDate(dayjs(props.selectedDate));
        }
    }, [props.selectedDate]);
    var onDateChange = function (value, context) {
        var updatedDate = value.hour() === 0 && value.minute() === 0 ? value.hour(12).minute(0) // Set time to 12 PM by default
            : value;
        if (value) {
            props.onChange(updatedDate.toISOString(), context);
        }
    };
    function updatePickerColor(color) {
        document.documentElement.style.setProperty('--picker-selected-color', color);
    }
    // Example usage:
    updatePickerColor(systemColor.primary);
    return /*#__PURE__*/ React.createElement(LocalizationProvider, {
        dateAdapter: AdapterDayjs
    }, /*#__PURE__*/ React.createElement(DateTimePicker, {
        className: "service-estimate-dtp",
        format: "MMM DD, YYYY - hh:mm a",
        minDate: minDate,
        ampm: true,
        disablePast: true,
        value: internalDate,
        open: isOpenDateTimePicker,
        onClose: function () { return setIsOpenDateTimePicker(false); },
        onOpen: function () {
            if (!internalDate) {
                setInternalDate(dayjs(new Date()).add(2, 'hours'));
                onDateChange(dayjs(new Date()).add(2, 'hours'), {
                    "validationError": null
                });
            }
        },
        onChange: function (value, context) { return onDateChange(value, context); },
        sx: _objectSpread(_objectSpread({}, props.sx), {}, {
            '& .MuiInputLabel-root': {
                color: '#8593A3'
            }
        }),
        slotProps: {
            dialog: {
                id: 'service-estimate-dtp-dialog'
            },
            layout: {
                sx: {
                    '& .MuiMultiSectionDigitalClock-root': {
                        '& .Mui-selected': {
                            color: '#ffff'
                        },
                        '& .MuiMultiSectionDigitalClockSection-root:nth-child(3)': {
                            overflow: 'initial'
                        }
                    }
                }
            },
            textField: {
                size: "small",
                onClick: function (e) {
                    e.stopPropagation();
                    if (props.isDisabled)
                        return;
                    setIsOpenDateTimePicker(true);
                    if (!internalDate) {
                        setInternalDate(dayjs(new Date()).add(2, 'hours'));
                        onDateChange(dayjs(new Date()).add(2, 'hours'), {
                            "validationError": null
                        });
                    }
                },
                InputProps: {
                    placeholder: t("Select date and time"),
                    endAdornment: /*#__PURE__*/ React.createElement(IconButton, {
                        id: "service-estimate-dtp-button",
                        onClick: function (e) {
                            e.stopPropagation();
                            setIsOpenDateTimePicker(true);
                            if (!internalDate) {
                                setInternalDate(dayjs(new Date()).add(2, 'hours'));
                                onDateChange(dayjs(new Date()).add(2, 'hours'), {
                                    "validationError": null
                                });
                            }
                        },
                        sx: {
                            mr: -1
                        },
                        disabled: props.isDisabled
                    }, /*#__PURE__*/ React.createElement("img", {
                        id: "calander-icon",
                        src: CalenderIconBlack,
                        alt: "calander-icon"
                    }))
                },
                disabled: props.isDisabled
            },
            toolbar: {
                sx: (_a = {},
                    _a["& .".concat(dateTimePickerToolbarClasses.timeDigitsContainer)] = (_b = {},
                        _b["& .".concat(pickersToolbarTextClasses.root)] = {
                            fontSize: 'xxl'
                        },
                        _b.alignItems = 'center',
                        _b),
                    _a)
            }
        },
        disabled: props.isDisabled,
        desktopModeMediaQuery: theme.breakpoints.up('sm')
    }));
};
export default DateTimePickerComponent;
